import React, { Fragment, useEffect } from 'react';
import Cookies from "js-cookie";
import Layout from "../Components/Reuseable/layout";
import Footer from "../Components/Reuseable/Footer.jsx";
import CoptRight from "../Components/Reuseable/Copyrights";
import { fetchNews, STATUSES } from "../redux/getReducer/getNewsSlice";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Banner from "../assets/Rectangle 16.jpg"
// import { htmlToText } from "html-to-text";
const BlogDetails = () => {
  const dispatch = useDispatch()
  const { data: allnews, status } = useSelector((state) => state.news);
  const { state } = useLocation()
  const cookiedata = Cookies.get("i18next");
  const { blogs } = state


  useEffect(() => {
    dispatch(fetchNews());

  }, [allnews, dispatch])
  if (status === STATUSES.LOADING) {
    return (
      <h2
        style={{
          margin: "100px",
        }}
      >

      </h2>
    );
  }

  if (status === STATUSES.ERROR) {
    return (
      <h2
        style={{
          margin: "100px",
        }}
      >
        Something went wrong!
      </h2>
    );
  }
  return (
    <Fragment>
      {/* <Layout /> */}
      <div className="aboutpageheader">
        <h2> Blogs </h2>
      </div>
      <div className='blogMain'>
        <h4>{cookiedata === "en" ? blogs.TitleEn : blogs.TitleAr}</h4>
        <div className='blogBanner'>
          <img src={Banner} alt="" />
        </div>
        {/* <p className='mt-5'>{htmlToText(blogs.DescriptionEn)}</p> */}
        <div className='blogDatas'>
          <div className='blogDesc'>
            {/* <p >{htmlToText(blogs.DescriptionEn)}</p> */}
          </div>
          <div>

            <img src={blogs.image} alt='' />
          </div>
        </div>
        {/* {
          allnews.map((item) => {
            return (
              <div className='blogDetailMain'>
                <h4>{cookiedata === "en" ? item.TitleEn : item.TitleAr}</h4>
                <div className=''>
                  <img src={item.image} alt="" />
                  <h2>{cookiedata === "en" ? item.TitleEn : item.TitleAr}</h2>
                  <h3>{cookiedata === "en" ? item.SecondTitleEn : item.SecondTitleAr}</h3>
                  <p>{cookiedata === "en" ? item.DescriptionEn : item.DescriptionAr}</p>
                </div>
              </div>
            )
          })
        }
        {/* <p className='mt-5'>{htmlToText(blogs.DescriptionEn)}</p> */}

      </div>
      <Footer />
      <CoptRight />
    </Fragment>
  )
}

export default BlogDetails